import { Text } from '@chakra-ui/react';
import { FC } from 'react';

import { parseAndReplaceHtmlTags } from '@/components/ui/shared/search/TagHighlight.utils';

interface ITagHighlightProps {
  htmlString: string;
}

export const TagHighlight: FC<ITagHighlightProps> = ({ htmlString }) => {
  return parseAndReplaceHtmlTags(
    htmlString,
    'em',
    <Text as="mark" bg="violet.50" color="violet.500" fontWeight="bold" fontStyle="initial" />
  );
};
